import styled from "@emotion/styled";
import { css } from "@emotion/react";
import { theme } from "@xometry/xometry_loft";

export const AddOptionLink = styled.div`
  margin-top: ${theme.space[1]};
  font-size: ${theme.fontSizes[0]};
  color: ${theme.colors.darkBlues[75]};
  > b {
    color: ${theme.colors.blues[100]};
    cursor: pointer;
  }
`;

export const SelectStyle = css`
  width: 100%;
`;
